module.exports = __webpack_public_path__ + "static/media/coffee_syrups.98334e64.JPG";